import React, { useState, useEffect } from "react";
import { Button, Form } from "react-bootstrap";
import { UserKyc } from "../../../../hooks/User";

const Step3 = ({ nextStep, prevStep, updateFormData, formData }) => {
  const [documents, setDocuments] = useState(formData.documents || [{ type: "", number: "", frontImage: null, backImage: null }]);
  const walletAddress = localStorage.getItem("WalletAddress");
  useEffect(() => {
    // If data is available, pre-fill the documents
    if (formData.documents) {
      setDocuments(formData.documents);
    }
  }, [formData]);

  const handleFileChange = (e, index, type) => {
    const files = e.target.files;
    const newDocuments = [...documents];
    newDocuments[index][type] = files[0];
    setDocuments(newDocuments);
  };

  const handleInputChange = (e, index, field) => {
    const value = e.target.value;
    const newDocuments = [...documents];
    newDocuments[index][field] = value;
    setDocuments(newDocuments);
  };
  console.log("documents", documents, formData);

  const handleSubmit = async (e) => {
    e.preventDefault();


    try {
      const submitObj = {
        walletAddress: walletAddress,
        address: {
          country: formData.country,
          state: formData.region,
          city: formData.city,
          address: formData.locality,
          pincode: formData.postal
        },
        fName: formData.firstName,
        lName: formData.lastName,
        username: formData.username,
        email: formData.email,
        bio: formData.bio
      }
      console.log("formDataToSend", submitObj, documents);
      const response = await UserKyc(submitObj);
      console.log("Form submitted successfully:", response.data);
      nextStep();
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Failed to submit the form. Please try again later.");
    }
  };

  const handleAddDocument = () => {
    setDocuments([...documents, { type: "", number: "", frontImage: null, backImage: null }]);
  };

  const renderImageUploadFields = (docType, index) => {
    switch (docType) {
      case "Aadhar":
      case "Driver's License":
      case "Voter ID":
        return (
          <>
            <Form.Group>
              <p className="mt-3">Front Image</p>
              <Form.Control
                type="file"
                accept=".jpg, .png, .pdf"
                onChange={(e) => handleFileChange(e, index, "frontImage")}
                required
              />
            </Form.Group>
            <Form.Group>
              <p className="mt-3">Back Image</p>
              <Form.Control
                type="file"
                accept=".jpg, .png, .pdf"
                onChange={(e) => handleFileChange(e, index, "backImage")}
                required
              />
            </Form.Group>
          </>
        );
      case "Passport":
      case "Pan Card":
        return (
          <Form.Group>
            <p className="mt-3">Front Image</p>
            <Form.Control
              type="file"
              accept=".jpg, .png, .pdf"
              onChange={(e) => handleFileChange(e, index, "frontImage")}
              required
            />
          </Form.Group>
        );
      default:
        return null;
    }
  };

  return (
    <div className="container">
      <Form className="box mt-4" 
      // onSubmit={handleSubmit}
      >
        <h3>Step 3: Upload Documents

        </h3>

        {documents.map((doc, index) => (
          <div key={index} className="mb-3">
            <h5>Document {index + 1}</h5>
            <Form.Group>
              <p className="mt-3">Document Type</p>
              <Form.Control
                as="select"
                value={doc.type}
                onChange={(e) => handleInputChange(e, index, "type")}
                // required
              >
                <option value="">Select Document Type</option>
                <option value="Passport">Passport</option>
                <option value="Aadhar">Aadhar</option>
                <option value="Driver's License">Driver's License</option>
                <option value="Voter ID">Voter ID</option>
                <option value="Pan Card">Pan Card</option>
              </Form.Control>
            </Form.Group>

            <Form.Group>
              <p className="mt-3">Document Number</p>
              <Form.Control
                type="text"
                value={doc.number}
                onChange={(e) => handleInputChange(e, index, "number")}
                // required
              />
            </Form.Group>

            {renderImageUploadFields(doc.type, index)}
          </div>
        ))}

        <Button variant="link btn-grad" onClick={handleAddDocument}>
          Add Another Document
        </Button>

        <div className="d-flex justify-content-between mt-3">
          <Button variant="secondary" onClick={prevStep}>
            Back
          </Button>
          <Button variant="primary"  onClick={handleSubmit}>
            Submit
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default Step3;
